module.exports = "/_next/static/images/add-e77a9fe0cd13c7bb2f52e040016018d2.png";